var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecibirpagosbitcoinditopay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6",
    "data-name": "Grupo 6",
    transform: "translate(-899 -970)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(899 970)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_000000ff",
    "data-name": "#000000ff",
    transform: "translate(896.472 967.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M41.041,24.125A19.255,19.255,0,1,1,31.4,28.086a19.293,19.293,0,0,1,9.638-3.961m-1.433,6.314c-.508.611-.267,1.464-.319,2.19-.948.018-1.9-.035-2.844.023A1.339,1.339,0,0,0,35.3,34.113V52.391a1.342,1.342,0,0,0,1.146,1.466c.945.058,1.893,0,2.841.023a6.182,6.182,0,0,0,.12,1.878,1.336,1.336,0,0,0,2.143.387c.594-.6.34-1.513.392-2.265H44.6a6.231,6.231,0,0,0,.12,1.878,1.338,1.338,0,0,0,2.147.385c.6-.606.334-1.531.387-2.29a5.993,5.993,0,0,0,3.106-10.6A6.1,6.1,0,0,0,52.5,39.461a5.984,5.984,0,0,0-1.853-5.243,6.15,6.15,0,0,0-3.4-1.562,6.415,6.415,0,0,0-.118-1.9,1.335,1.335,0,0,0-2.145-.4c-.6.6-.339,1.514-.39,2.268h-2.66c-.05-.721.184-1.566-.309-2.178A1.336,1.336,0,0,0,39.608,30.439Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M264.574,56.974c.516-.407,1.207-.214,1.8-.168a33.221,33.221,0,0,1,29.054,27.317c.714-.819,1.406-1.655,2.125-2.471a1.325,1.325,0,0,1,2.268,1.285,3.329,3.329,0,0,1-.614.867c-1.184,1.365-2.349,2.746-3.53,4.113a1.431,1.431,0,0,1-1.257.558c-.525-.008-.89-.427-1.308-.681-1.5-.946-3.007-1.876-4.508-2.821a1.325,1.325,0,0,1,.666-2.471,1.8,1.8,0,0,1,.966.359c.85.538,1.7,1.068,2.555,1.6a30.384,30.384,0,0,0-26.937-25.036,2.14,2.14,0,0,1-1.415-.435A1.334,1.334,0,0,1,264.574,56.974Z",
    transform: "translate(-200.176 -27.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M108,92c2.877,0,5.756,0,8.634,0a3.318,3.318,0,0,1,0,6.636c-2.879.008-5.758,0-8.639,0Z",
    transform: "translate(-70.041 -56.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M108,148c2.881,0,5.76,0,8.64,0a3.317,3.317,0,0,1,0,6.635c-2.877.008-5.756,0-8.635,0Z",
    transform: "translate(-70.041 -103.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M273,256.138a19.259,19.259,0,1,1-13.772,8.431A19.262,19.262,0,0,1,273,256.138m1.308,5.567c-.6.594-.342,1.511-.392,2.261a6.418,6.418,0,0,0-5.741,3.072,6.308,6.308,0,0,0,3.767,9.336c1.836.455,3.751.063,5.613.281a3.651,3.651,0,0,1-.656,7.242c-1.441.005-2.882.008-4.322,0a2.664,2.664,0,0,1-2.633-2.479,1.439,1.439,0,0,0-.792-1.38,1.329,1.329,0,0,0-1.861,1.018,5.3,5.3,0,0,0,3.478,5.175,8.513,8.513,0,0,0,3.146.325,6.118,6.118,0,0,0,.123,1.884,1.336,1.336,0,0,0,2.14.38c.594-.594.34-1.506.39-2.255a6.95,6.95,0,0,0,2.8-.52,6.3,6.3,0,0,0-1.954-12.08c-1.448-.09-2.9.042-4.347-.07a3.647,3.647,0,0,1,.334-7.254c1.557-.017,3.116-.022,4.675,0a2.69,2.69,0,0,1,2.48,2.652,1.322,1.322,0,0,0,2.632.169,5.29,5.29,0,0,0-2.8-4.861,7.145,7.145,0,0,0-3.827-.629,6.291,6.291,0,0,0-.123-1.878A1.336,1.336,0,0,0,274.309,261.7Z",
    transform: "translate(-193.453 -193.492)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M36.317,264.462a1.406,1.406,0,0,1,1.713-.312c1.753,1.187,3.593,2.241,5.363,3.405a1.32,1.32,0,0,1-1.4,2.233c-.971-.569-1.908-1.2-2.872-1.782A30.391,30.391,0,0,0,66.033,293.04a2.064,2.064,0,0,1,1.494.495,1.335,1.335,0,0,1-.2,1.961,2.158,2.158,0,0,1-1.619.183,33.234,33.234,0,0,1-29.23-27.335c-.686.79-1.358,1.592-2.044,2.383a1.4,1.4,0,0,1-1.1.563,1.329,1.329,0,0,1-1.325-1.327,1.66,1.66,0,0,1,.536-1.122C33.813,267.387,35.053,265.914,36.317,264.462Z",
    transform: "translate(-6.671 -200.146)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecibirpagosbitcoinditopay);
export default __webpack_public_path__ + "static/media/Recibir pagos bitcoin ditopay.c5db4eae6af0c697d3b7f56ece4ef28d.svg";
export { ForwardRef as ReactComponent };